import * as LJS from "../../../lib/littlejs.esm";
import Globals from "../../globals.ts";
import Actionable from "./actionable.ts";
/*
 * Actionables are objects you can encounter on the map and interact
 * with, such as levers, doors, etc.
 */
class RemotelyActionable extends Actionable {
    constructor(pos, tileIndex) {
        super(pos, tileIndex);
        // Overridden by the child class to make the actionable interactive
        this.key = "KeyE";
        this.state = "disabled";
        this.distance = 0;
        this.setCollision(false, false, false, false);
        this.mass = 0; // Not affected by gravity
    }
    // We override the default behavior of the actionables : here we
    // just display the message if there is one (i.e. "This door is
    // locked"), but we never call action(). It will have to
    // be called from an external class (i.e. a lever)
    update() {
        const distance = this.pos.distance(Globals.player.pos);
        if (distance < this.distance) {
            this.message();
        }
    }
    // Displays a message when we are near the actionable
    message() {
        LJS.drawTextOverlay("[E] Activate", LJS.vec2(this.pos.x, this.pos.y + 1), 0.5);
    }
    action() {
        console.log("Activated");
    }
}
export default RemotelyActionable;
